import { useState } from 'react';
import { IonGrid, IonRow, IonCol, IonInput, IonButton, IonSegment, IonSegmentButton, IonLabel, useIonToast } from '@ionic/react';
import { Constants } from '../../defines/Constants';
import { ValidateIranMobile, ValidateEmail } from '../../defines/Functions';
import axios from 'axios';
import Loading from '../Loading';
import './Subscribe.css';

const Subscribe = () => {
    const newsletterApi = Constants.api.newsletter;
    const [segValue, setSegValue] = useState('mobile');
    const [present] = useIonToast();
    const showToast = (options: any) => {
        present({
            buttons: [{ icon: 'close', role: 'cancel' }],
            message: options.message,
            color: options.color,
            duration: 2000
        })
    };
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        mobile: '',
        email: ''
    });
    const [required, setRequired] = useState({
        mobile: { value: false, message: '' },
        email: { value: false, message: '' }
    });
    const handleChange = (e: any) => {
        const name = e.target.name;
        const value = e.detail.value;
        setFormData(values => ({ ...values, [name]: value }));
    }
    const handleBlur = () => {
        if (segValue === 'mobile') {
            if (formData.mobile.toString().trim().length === 0) {
                setRequired(prevRequired => { return { ...prevRequired, mobile: { value: true, message: 'الزامی' } } });
            } else {
                if (!ValidateIranMobile(formData.mobile)) {
                    setRequired(prevRequired => { return { ...prevRequired, mobile: { value: true, message: 'شماره موبایل معتبر نیست' } } });
                } else {
                    setRequired(prevRequired => { return { ...prevRequired, mobile: { value: false, message: '' } } });
                }
            }
        } else {
            if (formData.email.toString().trim().length === 0) {
                setRequired(prevRequired => { return { ...prevRequired, email: { value: true, message: 'الزامی' } } });
            } else {
                if (!ValidateEmail(formData.email)) {
                    setRequired(prevRequired => { return { ...prevRequired, email: { value: true, message: 'آدرس ایمیل معتبر نیست' } } });
                } else {
                    setRequired(prevRequired => { return { ...prevRequired, email: { value: false, message: '' } } });
                }
            }
        }
    }
    const handleSubmit = (event: any) => {
        let isRequired = false;
        event.preventDefault();
        if (segValue === 'mobile') {
            if (formData.mobile.toString().trim().length === 0) {
                setRequired(prevRequired => { return { ...prevRequired, mobile: { value: true, message: 'الزامی' } } });
                isRequired = true;
            } else {
                if (!ValidateIranMobile(formData.mobile)) {
                    setRequired(prevRequired => { return { ...prevRequired, mobile: { value: true, message: 'شماره موبایل معتبر نیست' } } });
                    isRequired = true;
                } else {
                    setRequired(prevRequired => { return { ...prevRequired, mobile: { value: false, message: '' } } });
                    isRequired = false;
                }
            }
        } else {
            if (formData.email.toString().trim().length === 0) {
                setRequired(prevRequired => { return { ...prevRequired, email: { value: true, message: 'الزامی' } } });
                isRequired = true;
            } else {
                if (!ValidateEmail(formData.email)) {
                    setRequired(prevRequired => { return { ...prevRequired, email: { value: true, message: 'آدرس ایمیل معتبر نیست' } } });
                    isRequired = true;
                } else {
                    setRequired(prevRequired => { return { ...prevRequired, email: { value: false, message: '' } } });
                    isRequired = false;
                }
            }
        }
        if (!isRequired) {
            submitForm();
        }
    }
    const submitForm = async () => {
        setLoading(true);
        const submitData = {
            mobile: formData.mobile,
            email: formData.email
        };
        try {
            const formResults = await axios.post(newsletterApi, JSON.stringify(submitData), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            if (formResults.data.status === 'error') {
                showToast({ message: formResults.data.message, color: 'danger' });
                setFormData({
                    mobile: '',
                    email: ''
                });
                setLoading(false);
            } else {
                showToast({ message: formResults.data.message, color: 'success' });
                setFormData({
                    mobile: '',
                    email: ''
                });
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }
    return (
        <div className="form-subscribe-container">
            <form onSubmit={handleSubmit}>
                <IonGrid>
                    <IonRow>
                        {!loading ?
                            <IonCol size="12">
                                <h3 className="form-subscribe-title">عضویت در خبرنامه</h3>
                                <IonSegment mode="ios" value={segValue} onIonChange={e => setSegValue(e.detail.value!)}>
                                    <IonSegmentButton value="mobile">
                                        خبرنامه پیامکی
                                    </IonSegmentButton>
                                    <IonSegmentButton value="email">
                                        خبرنامه ایمیلی
                                    </IonSegmentButton>
                                </IonSegment>
                                {segValue === 'mobile' ?
                                    <>
                                        <IonLabel>
                                            شماره موبایل خود را وارد کنید
                                            {required.mobile.value ? <span className="required">{required.mobile.message}</span> : null}
                                        </IonLabel>
                                        <IonInput type="tel" name="mobile" value={formData.mobile || ''} onIonChange={handleChange} onIonBlur={handleBlur} />
                                    </>
                                    :
                                    <>
                                        <IonLabel>
                                            آدرس ایمیل خود را وارد کنید
                                            {required.email.value ? <span className="required">{required.email.message}</span> : null}
                                        </IonLabel>
                                        <IonInput type="email" name="email" value={formData.email || ''} onIonChange={handleChange} onIonBlur={handleBlur} />
                                    </>
                                }
                                <IonButton type="submit" color="warning" expand="block" className="form-subscribe-submit-button">
                                    عضویت
                                </IonButton>
                            </IonCol>
                            :
                            <Loading />
                        }
                    </IonRow>
                </IonGrid>
            </form>
        </div>
    );
};
export default Subscribe;